
export const CONFIG = {
  API_BASE: "https://rewritelabs.com/ventures/360haircam/api/",
  // API_BASE: "http://127.0.0.1:8090",
  
  TIMEOUTS: {
    CONNECTION: 30000,
    ICE_GATHERING: 5000,
    POLLING_MAX: 60000,
  },
  
  POLLING: {
    MINIMAL_INTERVAL: 3000,
    ADAPTIVE_INTERVALS: [500, 1000, 2000],
    ADAPTIVE_THRESHOLDS: [10, 30],
    MIN_ICE_CANDIDATES: 10,
  },
  
  WEBRTC: {
    ICE_SERVERS: [
      { urls: "stun:stun.l.google.com:19302" },
      { urls: "stun:stun1.l.google.com:19302" },
      { urls: "stun:stun2.l.google.com:19302" },
      { urls: "stun:stun.cloudflare.com:3478" },
    ],
    ICE_CANDIDATE_POOL_SIZE: 10,
  },
  
  // Camera constraints are now handled internally by CameraManager
  
  QR: {
    MAX_SCANS_PER_SECOND: 5,
    CANVAS_SIZE: 200,
    CANVAS_MARGIN: 2,
  },
  
  VIDEO: {
    ROTATION_STEP: 90,
    PANZOOM: {
      maxZoom: 4,
      minZoom: 1,
      initialZoom: 1,
      smoothScroll: false,
      bounds: true,
      boundsPadding: 0.1,
      pinchSpeed: 1,
      zoomSpeed: 1,
    },
  },
} as const;

export const ELEMENT_IDS = {
  // Screens
  INSTALL_SCREEN: "install-screen",
  MODE_SCREEN: "mode-screen", 
  VIEWER_SCREEN: "viewer-screen",
  CAMERA_SCREEN: "camera-screen",
  
  // Buttons
  INSTALL_BTN: "install-btn",
  SKIP_INSTALL: "skip-install",
  VIEWER_BTN: "viewer-btn",
  CAMERA_BTN: "camera-btn",
  BACK_FROM_VIEWER: "back-from-viewer",
  BACK_FROM_CAMERA: "back-from-camera",
  SWITCH_CAMERA_BTN: "switch-camera-btn",
  
  // Fullscreen buttons
  CLOSE_BTN: "close-btn",
  ROTATE_BTN: "rotate-btn",
  MIRROR_BTN: "mirror-btn",
  SNAPSHOT_BTN: "snapshot-btn",
  
  // Video elements
  SCANNER_VIDEO: "scanner-video",
  CAMERA_STREAM_VIDEO: "camera-stream-video",
  REMOTE_VIDEO: "remote-video",
  
  // Containers
  VIEWER_SETUP: "viewer-setup",
  FULLSCREEN_VIDEO: "fullscreen-video",
  VIDEO_SPLIT_CONTAINER: "video-split-container",
  VIDEO_CONTAINER: "video-container",
  SNAPSHOT_CONTAINER: "snapshot-container",
  SNAPSHOT_WRAPPER: "snapshot-wrapper",
  SNAPSHOT_IMAGE: "snapshot-image",
  QR_CANVAS: "qr-canvas",
  
  // Status
  CONNECTION_STATUS: "connection-status",
  CAMERA_CONNECTION_STATUS: "camera-connection-status",
  
  // Stats
  VIDEO_STATS: "video-stats",
  STATS_RESOLUTION: "stats-resolution",
  STATS_BITRATE: "stats-bitrate",
  STATS_FPS: "stats-fps",
  VIEWER_RESOLUTION: "viewer-resolution",
  VIEWER_STATS: "viewer-stats",
  VIEWER_STATS_RESOLUTION: "viewer-stats-resolution",
  VIEWER_STATS_BITRATE: "viewer-stats-bitrate",
  VIEWER_STATS_FPS: "viewer-stats-fps",
} as const;